import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import { createMuiTheme, Slide, Container, Dialog, AppBar, Toolbar, IconButton, Typography, Fab, CssBaseline, Backdrop, CircularProgress, Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PersonIcon from '@material-ui/icons/Person';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { HttpService } from "../../../apiAuthorization/httpService";
import { authenticationService } from "../../../apiAuthorization/authenticationService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import AddUserGroup from "../userGroup/userGroupAdd";
import UserGroupSetting from "./userGroupSetting";
import UserGroupModule from "../userGroup/userGroupModule";
import UserGroupUserList from "./userGroupUserList";
import AlertDialog from '../../common/alertDialog';
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserGroupList(props) {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const [backDrop, setBackDrop] = useState(true);
    const [userGroups, setUserGroups] = useState([]);
    const [appModuleGroupId, setAppModuleGroupId] = useState();
    const [userGroupEditOpen, setUserGroupEditOpen] = useState(false);
    const [userGroupSettingsOpen, setUserGroupSettingsOpen] = useState(false);
    const [userGroupModulesOpen, setUserGroupModulesOpen] = useState(false);
    const [userGroupUsersOpen, setUserGroupUsersOpen] = useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const currentUser = authenticationService.currentUserValue;

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const alertClose = () => {
        setAlertOpen(false);
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const addUserGroup = () => {
        setUserGroupEditOpen(true);
        setRecordToBeEdit([]);
    };

    const editUserGroup = (item) => {
        setUserGroupEditOpen(true);
        setRecordToBeEdit(item);
    };

    const closeUserGroupEdit = () => {
        setUserGroupEditOpen(false);
    };

    const openUserGroupSettings = (item) => {
        setUserGroupSettingsOpen(true);
        setRecordToBeEdit(item);
    };

    const closeUserGroupSettings = () => {
        setUserGroupSettingsOpen(false);
    };

    const opneUserGroupModules = (item) => {
        setUserGroupModulesOpen(true);
        setRecordToBeEdit(item);
    };

    const closeUserGroupModules = () => {
        setUserGroupModulesOpen(false);
    };

    const openUserGroupUsers = (item) => {
        setUserGroupUsersOpen(true);
        setRecordToBeEdit(item);
    };

    const closeUserGroupUsers = () => {
        setUserGroupUsersOpen(false);
    };

    const updateList = (item) => {
        if (item !== null) {
            const data = userGroups;
            const index = data.findIndex(data => data.AppModuleGroupId === item.AppModuleGroupId);
            if (index === -1)
                data.push(item);
            else
                data[index].AppModuleGroupName = item.AppModuleGroupName;
            setUserGroups(data);
        }
    };

    const deleteAppModuleGroupConfirm = (id) => {
        setConfirmOpen(true);
        setAppModuleGroupId(id);
    };

    const deleteAppModuleGroup = () => {
        setConfirmOpen(false);
        HttpService.post('/UserGroup/DeleteAppModuleGroup', { AppModuleGroupId: appModuleGroupId })
        .then((result) => {
            if (result.error) {
                setErrorMessage(result.message);
                setSeverity('error');
                setAlertOpen(true);
            }
            else {
                const data = userGroups.filter(item => item.AppModuleGroupId !== appModuleGroupId);
                setUserGroups(data);
            }
        },
        (error) => {
            console.log(error);
        });
    };

    const getUserGroups = () => {
        HttpService.post('/UserGroup/GetAppModuleGroups', { AppModuleGroupName: currentUser.Username })
        .then((result) => {
            setUserGroups(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getUserGroups();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="userGroupBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={userGroupEditOpen} onClose={closeUserGroupEdit} TransitionComponent={Transition}>
                        <AddUserGroup parentCallback={closeUserGroupEdit}
                            refreshGrid={updateList}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={userGroupSettingsOpen} onClose={closeUserGroupSettings} TransitionComponent={Transition}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={closeUserGroupSettings} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>User Group Settings</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={closeUserGroupSettings}>
                                        <CloseIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <UserGroupSetting model={recordToBeEdit} />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={userGroupModulesOpen} onClose={closeUserGroupModules} TransitionComponent={Transition}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={closeUserGroupModules} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>User Group Modules</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={closeUserGroupModules}>
                                        <CloseIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <UserGroupModule model={recordToBeEdit} />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={userGroupUsersOpen} onClose={closeUserGroupUsers} TransitionComponent={Transition}>
                        <UserGroupUserList parentCallback={closeUserGroupUsers} model={recordToBeEdit} />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link to="/"><KeyboardBackspaceIcon /></Link>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>&nbsp;User Groups</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={addUserGroup}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table" style={{ overflowY: "auto", scrollBehavior: "smooth", position: "absolute", top: "15px", bottom: "15px", left: "15px", right: "15px" }}>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Name</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-capitalize">
                                            {userGroups?.map((item, index) => (
                                                <tr key={item.AppModuleGroupId}>
                                                    <td style={rowStyle(index)}>{index + 1}</td>
                                                    <td style={rowStyle(index)}>{item.AppModuleGroupName}</td>
                                                    <td style={rowStyle(index)}>
                                                        <PersonIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => openUserGroupUsers(item)}/>
                                                        <DashboardIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right', display: item.AppModuleGroupName.toLowerCase() === 'administrator' ? 'none' : 'inline' }} onClick={() => opneUserGroupModules(item)}/>
                                                        <FormatListBulletedIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => openUserGroupSettings(item)}/>
                                                        <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right', display: item.AppModuleGroupName.toLowerCase() === 'administrator' ? 'none' : 'inline' }} onClick={() => deleteAppModuleGroupConfirm(item.AppModuleGroupId)}/>
                                                        <EditIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right', display: item.AppModuleGroupName.toLowerCase() === 'administrator' ? 'none' : 'inline' }} onClick={() => editUserGroup(item)}/>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteAppModuleGroup}
                                    title="Delete User Group" message="Are you sure you want to delete the selected User Group?" />
                                <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
